// // ============================================
// // src/components/home/ImpactAreasGrid.tsx
// // ============================================
// "use client";
// import { Box, Typography, Grid } from '@mui/material';
// import { impactAreas } from '@/data/impactAreasData';

// interface ImpactAreasGridProps {
//   isVisible: boolean;
// }

// export default function ImpactAreasGrid({ isVisible }: ImpactAreasGridProps) {
//   return (
//     <Box
//       sx={{
//         opacity: isVisible ? 1 : 0,
//         transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
//         transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1) 0.4s',
//         mb: 6,
//       }}
//     >
//       <Typography
//         variant="h5"
//         sx={{
//           fontWeight: 700,
//           textAlign: 'center',
//           mb: 4,
//           color: 'white',
//         }}
//       >
//         Áreas de Impacto
//       </Typography>

//       <Grid container spacing={3}>
//         {impactAreas.map((area, index) => {
//           const IconComponent = area.icon;
//           return (
//             <Grid key={index} size={{ xs: 6, sm: 4, md: 2 }}>
//               <Box
//                 sx={{
//                   textAlign: 'center',
//                   p: 3,
//                   borderRadius: 3,
//                   border: '1px solid rgba(255, 255, 255, 0.2)',
//                   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                   opacity: isVisible ? 1 : 0,
//                   transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
//                   transitionDelay: `${0.05}s`,
//                   '&:hover': {
//                     transform: 'translateY(-8px)',
//                     boxShadow: '0 12px 24px rgba(0, 0, 0, 0.3)',
//                     borderColor: area.color,
//                     background: 'rgba(255, 255, 255, 0.15)',
//                   },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 64,
//                     height: 64,
//                     borderRadius: 2,
//                     bgcolor: `${area.color}40`,
//                     color: area.color,
//                     mb: 2,
//                   }}
//                 >
//                   <IconComponent sx={{ fontSize: 32 }} />
//                 </Box>
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontWeight: 600,
//                     color: 'white',
//                     fontSize: '0.875rem',
//                   }}
//                 >
//                   {area.title}
//                 </Typography>
//               </Box>
//             </Grid>
//           );
//         })}
//       </Grid>
//     </Box>
//   );
// }





// ============================================
// src/components/home/ImpactAreasGrid.tsx - VERSIÓN OPTIMIZADA
// ============================================
"use client";
import { memo } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { impactAreas } from '@/data/impactAreasData';

interface ImpactAreasGridProps {
  isVisible: boolean;
}

// Constantes
const ANIMATION_DELAY = '0.05s';
const IMPACT_STYLES = {
  title: {
    fontWeight: 700,
    textAlign: 'center' as const,
    mb: 4,
    color: 'white',
  },
  container: {
    mb: 6,
  },
} as const;

// Componente memoizado para cada área
const ImpactAreaItem = memo(({ 
  area, 
  isVisible 
}: { 
  area: typeof impactAreas[number]; 
  isVisible: boolean;
}) => {
  const IconComponent = area.icon;
  
  return (
    <Grid size={{ xs: 6, sm: 4, md: 2 }}>
      <Box
        sx={{
          textAlign: 'center',
          p: 3,
          borderRadius: 3,
          border: '1px solid rgba(255, 255, 255, 0.2)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transitionDelay: ANIMATION_DELAY,
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 24px rgba(0, 0, 0, 0.3)',
            borderColor: area.color,
            background: 'rgba(255, 255, 255, 0.15)',
          },
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 64,
            height: 64,
            borderRadius: 2,
            bgcolor: `${area.color}40`,
            color: area.color,
            mb: 2,
          }}
        >
          <IconComponent sx={{ fontSize: 32 }} />
        </Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: 'white',
            fontSize: '0.875rem',
          }}
        >
          {area.title}
        </Typography>
      </Box>
    </Grid>
  );
});

ImpactAreaItem.displayName = 'ImpactAreaItem';

const ImpactAreasGrid = memo(({ isVisible }: ImpactAreasGridProps) => {
  return (
    <Box
      sx={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1) 0.4s',
        mb: 6,
      }}
    >
      <Typography variant="h5" sx={IMPACT_STYLES.title}>
        Áreas de Impacto
      </Typography>

      <Grid container spacing={3}>
        {impactAreas.map((area) => (
          <ImpactAreaItem 
            key={area.title}
            area={area} 
            isVisible={isVisible} 
          />
        ))}
      </Grid>
    </Box>
  );
});

ImpactAreasGrid.displayName = 'ImpactAreasGrid';

export default ImpactAreasGrid;